// src/api/tags.js
const API_URL = "https://lborrito.de/api/v1/tags";

/**
 * 🔹 Alle Tags abrufen
 * GET /api/v1/tags
 */
export async function fetchAllTags() {
  const res = await fetch(API_URL, {
    method: "GET",
    credentials: "include", // JWT-Cookie mitschicken
  });

  if (!res.ok) {
    throw new Error("Fehler beim Laden der Tags");
  }

  return res.json(); // -> [{ id, name, label, type, description, defaultCheckmark }]
}

/**
 * 🔹 Tags suchen
 * GET /api/v1/tags?q=searchTerm
 */
export async function searchTags(query) {
  if (!query || !query.trim()) {
    return [];
  }
  
  const url = `${API_URL}?q=${encodeURIComponent(query)}`;
  const res = await fetch(url, {
    method: "GET",
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error("Fehler beim Suchen der Tags");
  }

  return res.json(); // -> [{ id, name, label, type, description, defaultCheckmark }]
}

/**
 * 🔹 Einen neuen Tag anlegen
 * POST /api/v1/tags
 */
export async function createTag({ label, type = "Basic", description = "", defaultCheckmark = false }) {
  const res = await fetch(API_URL, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      label,
      type,
      description,
      defaultCheckmark,
    }),
  });

  if (!res.ok) {
    throw new Error("Fehler beim Erstellen des Tags");
  }

  return res.json(); // -> { id, name, label, type, description, ... }
}


